import React from "react";
import Instructions from "../book-a-session/instructions/Instructions";
import Common_Title from "../common/common-title/Common_Title";

const Test_instructions = () => {
  return (
    <section className="Book_A_Session">
      <div className="container">
        <Common_Title
          title="Instructions"
          // subtitle=" ⚠️ Do not press ESC or exit fullscreen. Test will auto-submit."
        />
        <Instructions />
      </div>
    </section>
  );
};

export default Test_instructions;
